import React from "react";

interface ChatSidebarFlexSpacerProps {
  isChatSidebarOpen: boolean;
  width?: number;
  isResizing?: boolean;
  /**
   * Marks this instance as the popover clamp boundary (`data-chat-sidebar-spacer`), read by
   * usePopoverPosition as the right bound for edit popovers. Set ONLY on the content-row
   * spacer: the navbar renders two more instances earlier in the DOM whose left edges are
   * inset by nav padding, so an unqualified querySelector would clamp against the wrong one.
   */
  isPopoverBoundary?: boolean;
}

/**
 * Spacer component for right sidebars. Takes up space when a sidebar is open
 * so dashboard content doesn't get obscured.
 */
export const ChatSidebarFlexSpacer: React.FC<ChatSidebarFlexSpacerProps> = ({
  isChatSidebarOpen,
  width = 360,
  isResizing = false,
  isPopoverBoundary = false,
}) => {
  return (
    <div
      // usePopoverPosition reads the boundary spacer's left edge as the right bound for
      // edit popovers: the sidebar overlays the full-width iframe, so the spacer is the
      // only in-iframe element that tracks exactly where visible content ends.
      {...(isPopoverBoundary ? { "data-chat-sidebar-spacer": true } : {})}
      className={
        "flex-none " +
        (isResizing ? "" : "transition-width duration-300 ease-in-out ") +
        // The chat sidebar's entry point (Ask/Edit) is hidden below 640px, but if a session
        // already has it open before the viewport narrows (e.g. resizing an existing desktop
        // window), this !important override stops the reserved width — up to 700px, set via the
        // inline style below — from eating the entire mobile viewport.
        "max-sm:!w-0"
      }
      style={{ width: isChatSidebarOpen ? width : 0 }}
    ></div>
  );
};
